import {Script} from 'gatsby'
import React from 'react'

import useHasMounted from '@/hooks/use-has-mounted'
import {Scripts} from '@/utils/external-scripts'

interface TypeformSurveyProps {
    formId: string
    isStagingOnly: boolean
}

/**
 * Don't render the form if:
 * - no formId is provided
 * - it's staging only and we're in production
 * - the component hasn't mounted yet
 */
export const TypeformSurvey = ({formId, isStagingOnly}: TypeformSurveyProps) => {
    const hasMounted = useHasMounted()
    const shouldRenderForm =
        hasMounted && formId && !(isStagingOnly && process.env.GATSBY_ACTIVE_ENV === 'production')

    if (!shouldRenderForm) {
        return null
    }

    return (
        <>
            <Script strategy="idle" src={Scripts.TYPEFORM_SCRIPT_SRC} />
            <div data-tf-live={formId} style={{height: 0}} />
        </>
    )
}
